<template>
  <PageMain class="search-wapper bg-w  mt-20">
    <a-tabs v-model="dkey" type="card" class="search-tab pt-20">
      <a-tab-pane :key="1" :tab="'待取件（'+count+'）'">
        <LeftList @count="getCount" />
      </a-tab-pane>
      <a-tab-pane :key="2" :tab="'所有订单（'+total+'）'" force-render>
        <RightList @count="getTotal" />
      </a-tab-pane>

    </a-tabs>
    <a-button class="search-btn" type="primary" @click="$router.push('/main/trace')">单号查询</a-button>
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import LeftList from './leftList'
import RightList from './rightList'

export default {
  name: 'Search',
  components: {
    LeftList, RightList
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      count: 0,
      total: 0,
      dkey: 1
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.query.tab) {
        this.dkey = +this.$route.query.tab
      }
    })
  },
  methods: {
    getCount(count) {
      this.count = count
    },
    getTotal(total) {
      this.total = total
    }
  }
}
</script>

<style lang="scss" >
.search-wapper {
  position: relative;
.search-tab{
  .ant-tabs-nav-scroll{
  padding: 0 20px;

  }

}
 .search-btn{
    position: absolute;
    top: 6px;
    right: 20px;
  }
}

</style>
